import bg0 from "../Images/bg0.jpg";
import bg1 from "../Images/bg1.jpg";
import bg2 from "../Images/bg2.jpg";
import bg3 from "../Images/bg3.jpg";
import bg4 from "../Images/bg4.jpg";
import bg5 from "../Images/bg5.jpg";
import bg6 from "../Images/bg6.jpg";
import bg7 from "../Images/bg7.jpg";
import bg8 from "../Images/bg8.jpg";

let allImages = [];
allImages.push(bg0);
allImages.push(bg1);
allImages.push(bg2);
allImages.push(bg3);
allImages.push(bg4);
allImages.push(bg5);
allImages.push(bg6);
allImages.push(bg7);
allImages.push(bg8);

export default allImages;
